import React from 'react';
import PropTypes from 'prop-types';
import TaxFlowChartButton from './TaxFlowChartButton';

export default class TaxFlowChartSectionTwo extends React.Component {
  constructor() {
    super();
    this.renderMobileView = this.renderMobileView.bind(this);
    this.renderDesktopView = this.renderDesktopView.bind(this);
  }

  renderMobileView() {
    return (
      <div className="row tax-flow-chart-question-two-no">
        <div className="col-xs-6 col-sm-2 col-xs-offset-3 ">
          <img src={`${this.props.cdnURL}/images/TaxFlowChart/not-eligible-2x.png`} alt="Not Eligible" />
        </div>
        <div className="col-xs-12 col-sm-4">
          <p>No, you are not eligible to file as a sole proprietor</p>
        </div>
        <div className="col-sm-2 tax-flow-chart-pipe hidden-xs">
          {this.props.section === 1 &&
            <img src={this.props.iconSrc} alt="User Icon" />
          }
        </div>
      </div>
    );
  }

  renderDesktopView() {
    let filingClass = '';
    if (this.props.section >= 2) {
      filingClass = this.props.isSingle ? 'single' : 'joint';
    }
    const activeRowClass = this.props.section === 1 ? 'active' : '';
    const answerActive = this.props.section === 2 ? 'active' : '';
    const answeredQuestionClass = this.props.section > 2 ? 'done' : '';
    const singleButtonActive = this.props.section > 1 && this.props.isSingle ? 'active' : '';
    const jointButtonActive = this.props.section > 1 && !this.props.isSingle ? 'active' : '';
    return (
      <React.Fragment>
        <div className={`row tax-flow-chart-question-two row-eq-height ${activeRowClass}`}>
          <div className="col-xs-12 visible-xs">
            <img src={`${this.props.cdnURL}/images/TaxFlowChart/question2-2x.png`} alt="Mailbox" />
            <p> How are you filing? </p>
          </div>
          <div className="col-sm-2 col-sm-offset-1 tax-flow-chart-pipe hidden-xs">
            {this.props.section === 1 &&
              <img src={this.props.iconSrc} alt="User Icon" />
            }
            <p className="tax-flow-chart-overflow-text"> How are you filing? </p>
          </div>
          <div className="col-sm-5 col-sm-offset-2 hidden-xs">
            <img src={`${this.props.cdnURL}/images/TaxFlowChart/question2-2x.png`} alt="Mailbox" />
          </div>
        </div>
        <div className="row tax-flow-chart-answer-two-mobile tax-flow-chart-button-row">
          <TaxFlowChartButton
            colClasses="tax-flow-chart-button-col-left visible-xs"
            buttonClasses={`tax-flow-chart-button-yes ${singleButtonActive}`}
            onClick={() => this.props.setFilingStatus(true)}
            text="I am filing as an individual"
          />
          <TaxFlowChartButton
            colClasses="tax-flow-chart-button-col-right visible-xs"
            buttonClasses={`${jointButtonActive}`}
            onClick={() => this.props.setFilingStatus(false)}
            text="I am legally married and am filing jointly with my partner"
          />
        </div>
        <div className={`row tax-flow-chart-answer-two-top ${answeredQuestionClass} ${answerActive}`}>
          <TaxFlowChartButton
            colClasses={`col-sm-4 col-sm-offset-4 hidden-xs single-button ${filingClass}`}
            buttonClasses={`tax-flow-chart-button-yes ${singleButtonActive}`}
            onClick={() => this.props.setFilingStatus(true)}
            text="I am filing as an individual"
          />
        </div>
        <div className={`row tax-flow-chart-answer-two-bottom ${answeredQuestionClass} ${answerActive}`}>
          <TaxFlowChartButton
            colClasses={`col-sm-4 col-sm-offset-4 hidden-xs joint-button ${filingClass}`}
            buttonClasses={`${jointButtonActive}`}
            onClick={() => this.props.setFilingStatus(false)}
            text="I am legally married and am filing jointly with my partner"
          />
        </div>
      </React.Fragment>
    );
  }

  render() {
    if (!this.props.eligible && this.props.section === 1) {
      return this.renderMobileView();
    }
    return this.renderDesktopView();
  }
}

TaxFlowChartSectionTwo.propTypes = {
  section: PropTypes.number.isRequired,
  eligible: PropTypes.bool.isRequired,
  setFilingStatus: PropTypes.func.isRequired,
  isSingle: PropTypes.bool.isRequired,
  iconSrc: PropTypes.string.isRequired,
  cdnURL: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/TaxFlowChart/components/TaxFlowChartSectionTwo.jsx